import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { 
  findProductById, 
 
  getProductImage, 
  getProductCsvLookupId 
} from '../../utils/productHelpers';

const SimpleLiveScopePlusLVS34 = () => {
  console.log('🎯 SimpleLiveScopePlusLVS34 component loading');
  
  const product = findProductById("livescope-plus-lvs34");
  
  if (!product) {
    console.error('Product not found:', "livescope-plus-lvs34");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="livescope-plus-lvs34"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
      csvExactMatchOnly={true}
    />
  );
};

export default SimpleLiveScopePlusLVS34; 